
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 20 20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M6.923 10a3.077 3.077 0 106.154 0 3.077 3.077 0 00-6.154 0zm7.277 6.811l-3.766-3.766m2.611-2.61L16.81 14.2m-13.622 0l3.767-3.766m2.611 2.612L5.8 16.81m0-13.62l3.766 3.765M6.955 9.566L3.188 5.8m13.622 0l-3.765 3.766m-2.611-2.611l3.767-3.765","stroke":"currentColor","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M2 10a8 8 0 1016 0 8 8 0 00-16 0v0z","stroke":"currentColor","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    